import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const defaultColorLimits = [
    { min: 0, color: THEME.DANGEROUS },
    { min: 0.5, color: THEME.WARNING },
    { min: 0.8, color: THEME.SUCCESS },
];
const getColorForValue = (value, limits) => {
    let color = limits[0]?.color ?? THEME.COLOR_PRIMARY;
    for (const limit of limits) {
        if (value >= limit.min) {
            color = limit.color;
        }
    }
    return color;
};
const ProgressBar = ({ value, colorLimits = defaultColorLimits, threshold, showPercentage = true, }) => {
    const percentage = Math.round(value * 100);
    const color = getColorForValue(value, colorLimits);
    return (React.createElement(Container, null,
        React.createElement(BarWrapper, null,
            React.createElement(Bar, { $percentage: percentage, $color: color }),
            threshold != null && React.createElement(ThresholdMarker, { $position: threshold * 100 })),
        showPercentage && React.createElement(PercentageText, null,
            percentage,
            "%")));
};
const Container = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;
const BarWrapper = styled.div `
  flex: 1;
  position: relative;
  height: 12px;
  display: flex;
  align-items: center;
`;
const Bar = styled.div `
  width: 100%;
  height: 8px;
  background: ${THEME.BACKGROUND};
  border-radius: 4px;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${(props) => props.$percentage}%;
    background: ${(props) => props.$color};
    border-radius: 4px;
    transition: width 0.3s ease;
  }
`;
const ThresholdMarker = styled.div `
  position: absolute;
  left: ${(props) => props.$position}%;
  top: 0;
  width: 2px;
  height: 100%;
  background: ${THEME.COLOR_PRIMARY};
  border-radius: 1px;
  transform: translateX(-50%);
`;
const PercentageText = styled.span `
  font-size: 0.85em;
  min-width: 35px;
  text-align: right;
`;
export default ProgressBar;
//# sourceMappingURL=ProgressBar.js.map